import { render } from "./DefaultLayout.vue?vue&type=template&id=4f8c5366"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=4f8c5366&lang=css"
script.render = render

export default script